import {useParams} from "react-router-dom";
import React from "react";
import {BarChart} from "@mui/x-charts";
import useBearingTemps from "../../../hooks/Compressor/useBearingTemps";
import ValueNotReceivedMessage from "../../../components/ValueNotReceivedMessage/ValueNotReceivedMessage";
import {ChartSkeleton} from "../../../components/Skeletons/ChartSkeleton";
import './bearingsTab.scss';

function BearingsTab() {
    const params = useParams();
    const frameSerialNumber = params.frameSerialNumber!;
    const bearingTemps = useBearingTemps({frameSerialNumber});

    if (bearingTemps.isLoading) {
        return (
            <div className={'bearings-tab-container'}>
                <div className={`e-card`} style={{width: '50%', height: '30em', padding: '1em', alignItems: 'center'}}>
                    <h6>Bearing Temperatures</h6>
                    <ChartSkeleton/>
                </div>
            </div>
        );
    }
    if (!bearingTemps.data || bearingTemps.data.length === 0) {
        return (
            <div className={'bearings-tab-container'}>
                <div className={`e-card`} style={{width: '50%', height: '30em', padding: '1em', alignItems: 'center'}}>
                    <h6>Bearing Temperatures</h6>
                    <div style={{flex: 1, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <ValueNotReceivedMessage/>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={'bearings-tab-container'}>
            <div className={`e-card chart-container`}>
            <h6>Bearing Temperatures</h6>
                <BarChart
                    width={bearingTemps.data.length * 200 + 50}
                    height={400}
                    series={[{dataKey: 'value', color: '#003e70'}]}
                    dataset={bearingTemps.data!.map((item) => ({
                        name: item.displayName.replace('Temperature', ''),
                        value: parseFloat(item.value)
                    }))}
                    yAxis={[{
                        label: 'Temperature (°F)',
                    }]}
                    grid={{horizontal: true, vertical: false}}
                    xAxis={[{
                        dataKey: 'name',
                        scaleType: 'band',
                        //@ts-ignore because typescript is drunk. This is a valid prop
                        categoryGapRatio: 0.5,
                        tickSize: 10,
                        tickPlacement: 'middle',
                        tickLabelStyle: {
                            fontSize: 16,
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            wordBreak: 'break-all'
                        },
                        tickLabelInterval: ()=>true
                    }]}         
                />
            </div>
        </div>
    );
}

export default BearingsTab;